<lib-dialog>
  <div class="importar-asiento-dialog">
    <div class="dialog-header">
      <h3 class="dialog-title">Importar Asiento Contable</h3>
      <button
        type="button"
        class="close-btn"
        (click)="onCancel()"
        [disabled]="loading()"
        aria-label="Cerrar"
      >
        ✕
      </button>
    </div>

    <div class="steps-indicator">
      <div class="step" [class.active]="currentStep() === 1" [class.completed]="step1Completed()">
        <div class="step-number">1</div>
        <div class="step-label">Subir Archivo</div>
      </div>
      <div class="step-line" [class.active]="currentStep() >= 2"></div>
      <div class="step" [class.active]="currentStep() === 2" [class.completed]="step2Completed()">
        <div class="step-number">2</div>
        <div class="step-label">Validar Datos</div>
      </div>
      <div class="step-line" [class.active]="currentStep() >= 3"></div>
      <div class="step" [class.active]="currentStep() === 3">
        <div class="step-number">3</div>
        <div class="step-label">Procesar</div>
      </div>
    </div>

    <div class="dialog-content">
      @if (currentStep() === 1) {
        <div class="step-content">
          <div class="import-section">
            <h4 class="section-title">Importar desde archivo</h4>
            <lib-file-upload
              [accept]="'.csv,.xlsx,.xls,.txt'"
              [maxSize]="5242880"
              [multiple]="false"
              [label]="'Seleccionar archivo'"
              [hint]="
                'Formatos: CSV, TXT, Excel (XLSX, XLS). Plantilla HT016: 8 columnas. Tamaño máximo: 5MB'
              "
              (filesSelected)="onFilesSelected($event)"
            >
            </lib-file-upload>
          </div>

          @if (archivoSeleccionado()) {
            <div class="header-checkbox-container">
              <lib-checkbox
                [label]="'El archivo tiene fila de encabezado'"
                [(checked)]="tieneEncabezado"
              >
              </lib-checkbox>
              <span class="checkbox-hint"
                >Si el archivo tiene una primera fila con nombres de columnas, marque esta
                opción.</span
              >
            </div>
          }

          @if (archivoSeleccionado()) {
            <div class="file-info-card">
              <div class="file-info-header">
                <lib-icon name="FileText"></lib-icon>
                <div class="file-info-details">
                  <h4>{{ archivoSeleccionado()?.name }}</h4>
                  <p>
                    {{ archivoSeleccionado()?.size || 0 | number }} bytes -
                    {{ archivoSeleccionado()?.type }}
                  </p>
                </div>
              </div>
              <div class="file-info-actions">
                <lib-button variant="secondary" prefixIcon="Trash2" (clicked)="limpiarArchivo()">
                  Eliminar
                </lib-button>
                <lib-button
                  variant="primary"
                  prefixIcon="Upload"
                  [loading]="procesandoArchivo()"
                  [disabled]="procesandoArchivo()"
                  (clicked)="procesarArchivoSeleccionado()"
                >
                  {{ procesandoArchivo() ? 'Procesando...' : 'Procesar Archivo' }}
                </lib-button>
              </div>
            </div>
          }
        </div>
      }

      @if (currentStep() === 2) {
        <div class="step-content">
          @if (mostrarAlerta()) {
            <lib-alert
              [type]="alertaTipo()"
              [title]="alertaTitulo()"
              [message]="alertaMensaje()"
              [autoClose]="false"
              [closeButton]="true"
              (closed)="cerrarAlerta()"
            ></lib-alert>
          }

          <div class="file-summary">
            <div class="summary-item">
              <lib-icon name="FileText"></lib-icon>
              <span><strong>Archivo:</strong> {{ nombreArchivo() }}</span>
            </div>
            <div class="summary-item">
              <lib-icon name="Table"></lib-icon>
              <span><strong>Líneas:</strong> {{ lineas().length }}</span>
            </div>
            <div class="summary-item">
              <span><strong>Tipo:</strong> {{ tipoArchivo() }}</span>
            </div>
          </div>

          <div class="table-wrapper">
            <lib-table
              [config]="tableConfig()"
              [data]="lineas()"
              [loading]="procesandoArchivo()"
              [selectable]="false"
              (action)="onTableAction($event)"
            >
            </lib-table>
          </div>

          <div class="totales-section">
            <div class="total-item">
              <span class="total-label">Total Débito:</span>
              <span class="total-value">{{ totalDebito() | number: '1.2-2' }}</span>
            </div>
            <div class="total-item">
              <span class="total-label">Total Crédito:</span>
              <span class="total-value">{{ totalCredito() | number: '1.2-2' }}</span>
            </div>
            <div class="total-item" [class.different]="diferencia() !== 0">
              <span class="total-label">Diferencia:</span>
              <span class="total-value">{{ diferencia() | number: '1.2-2' }}</span>
            </div>
          </div>
        </div>
      }

      @if (currentStep() === 3) {
        <div class="step-content step-processing">
          <div class="processing-container">
            <h3>Procesando Asiento Contable</h3>
            <div class="progress-container">
              <div class="progress-bar">
                <div
                  class="progress-fill"
                  [class.completed]="progreso() === 100"
                  [style.width.%]="progreso()"
                ></div>
              </div>
              <div class="progress-text" [class.completed]="progreso() === 100">
                <span>{{ progreso() }}% completado</span>
              </div>
            </div>

            <div class="processing-details">
              <div class="detail-item">
                <span class="detail-label">Archivo:</span>
                <span class="detail-value">{{ nombreArchivo() }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Líneas a procesar:</span>
                <span class="detail-value">{{ totalLineasAProcesar() }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Estado:</span>
                <span class="detail-value status-text" [class.completed]="progreso() === 100">
                  {{ estadoProcesamiento() }}
                </span>
              </div>
            </div>

            <div class="processing-actions">
              <lib-button
                variant="primary"
                [disabled]="!procesamientoCompletado()"
                (clicked)="finalizarProcesamiento()"
              >
                {{ progreso() === 100 ? 'Continuar' : 'Procesando...' }}
              </lib-button>
            </div>
          </div>
        </div>
      }
    </div>

    @if (currentStep() === 2) {
      <div class="dialog-footer">
        <div class="actions">
          <lib-button variant="secondary" [disabled]="loading()" (clicked)="volverStep1()">
            Anterior
          </lib-button>
          <lib-button variant="secondary" [disabled]="loading()" (clicked)="onCancel()">
            Cancelar
          </lib-button>
          <lib-button
            variant="primary"
            [disabled]="loading() || !isFormularioValido()"
            (clicked)="irStep3()"
          >
            Procesar Asiento
          </lib-button>
        </div>
      </div>
    }

    @if (currentStep() === 1) {
      <div class="dialog-footer">
        <div class="actions">
          <lib-button variant="secondary" [disabled]="loading()" (clicked)="onCancel()">
            Cancelar
          </lib-button>
        </div>
      </div>
    }
  </div>
</lib-dialog>
